<template>
    <div
        v-if="reports"
        class="sustainability-page-reports"
    >
        <div class="container">
            <z-caption
                tag="a"
                size="3xl"
                href="/investors/reports-and-results/annual-reports/"
                decor-left
                decor-right
                class="sustainability-page-reports__title sustainability-page__title"
            >
                {{ text.title }}
            </z-caption>
        </div>

        <div class="sustainability-page-reports__body">
            <div
                ref="slider"
                class="sustainability-page-reports__slider swiper-container"
            >
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <report-block
                            :horizontal="true"
                            :data="dataBook"
                            class="sustainability-page-reports__report"
                        />
                    </div>
                    <div
                        v-for="(report, index) in reports"
                        :key="index"
                        class="swiper-slide"
                    >
                    <report-block
                        horizontal
                        :data="report"
                        class="sustainability-page-reports__report"
                    />
                    </div>
                    <div
                        v-if="reports.length < 3"
                        class="swiper-slide swiper-slide--card"
                    >
                        <div class="sustainability-page-reports__card">
                            <z-caption
                                tag="p"
                                size="l"
                                class="sustainability-page-reports__card-title"
                            >
                                <p v-html="text.card.title" />
                            </z-caption>
                            <z-button
                                tag="a"
                                kind="text"
                                size="l"
                                href="investors/reports-and-results/annual-reports/"
                                class="sustainability-page-reports__card-btn"
                            >
                                <template v-slot:left>
                                    <z-icon
                                        name="arrow-long"
                                        dir="right"
                                        width="16px"
                                        height="16px"
                                    ></z-icon>
                                </template>
                                <span v-html="text.card.linkText" />
                            </z-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'
import Swiper from 'swiper/dist/js/swiper.js'

export default {
    name: 'reports',
    props: {
        reports: Array
    },
    data () {
        return {
            slider: null,
            dataBook: {
                image: '/images/sustainability/new/databook.webp',
                name: 'ESG <br/> data book',
                fileLink: localize({
                    ru: '/files/ru/sustainability/ESG_Databook_RUS.xlsx',
                    en: '/files/en/sustainability/ESG_Databook_EN.xlsx'
                })
            },
            text: {
                title: localize({
                    ru: 'Отчеты',
                    en: 'Reports'
                }),
                databook: {
                    title: localize({
                        ru: 'ESG <br/> data book',
                        en: 'ESG <br/> data book'
                    })
                },
                card: {
                    title: localize({
                        ru: 'Подробнее о&nbsp;результатах нашей деятельности в&nbsp;годовых отчетах &laquo;Норникель&raquo;',
                        en: 'More about the results of&nbsp;our activities in&nbsp;the annual reports of&nbsp;&laquo;Norilsk Nickel&raquo;'
                    }),
                    linkText: localize({
                        ru: 'Все отчеты',
                        en: 'All Reports'
                    })
                }
            }
        }
    },
    methods: {
        init () {
            const options = {
                observeParents: true,
                grabCursor: true,
                slidesPerView: 'auto',
                spaceBetween: 138,
                breakpoints: {
                    1679: {
                        spaceBetween: 112
                    },
                    1359: {
                        spaceBetween: 80
                    },
                    1023: {
                        spaceBetween: 64
                    },
                    599: {
                        spaceBetween: 48
                    }
                }
            }

            this.slider = new Swiper(this.$refs.slider, options)
        }
    },
    mounted () {
        this.init()
    }
}
</script>

<style lang="scss">
.sustainability-page-reports {
    padding-top: $token-spacers-l;

    @include breakpoint(tablet) {
        padding-top: $token-spacers-s;
    }

    @include breakpoint(mobile) {
        background: $token-colors-gray-10;
        padding-top: 14px;
    }

    &__body {
        display: flex;
        margin-left: calc((100vw - 1920px) / 2 + 80px);
        margin-right: calc((100vw - 1920px) / 2 + 80px);

        @include breakpoint(laptop) {
            margin-left: 40px;
            margin-right: 40px;
        }

        @include breakpoint(v-tablet) {
            margin-left: 32px;
            margin-right: 32px;
        }

        @include breakpoint(mobile) {
            margin-top: 8px;
            margin-left: 16px;
            margin-right: 16px;
        }
    }

    &__slider {
        padding: 0 calc((100vw - 1920px) / 2 + 80px);
        margin: 0 calc(((100vw - 1920px) / 2 + 80px) * -1);

        @include breakpoint(laptop) {
            padding: 0 40px;
            margin: 0 -40px;
        }

        @include breakpoint(v-tablet) {
            padding: 0 32px;
            margin: 0 -32px;
        }

        @include breakpoint(mobile) {
            padding: 0 16px;
            margin: 0 -16px;
        }

        .swiper-slide {
            width: 300px;
            display: flex;
            padding-bottom: $token-spacers-2-xl;

            @include breakpoint(v-tablet) {
                width: 270px;
            }

            @include breakpoint(mobile) {
                padding-bottom: $token-spacers-xs;
            }

            &--card {
                width: 490px;

                @include breakpoint(v-tablet) {
                    width: 360px;
                }

                @include breakpoint(mobile) {
                    width: 288px;
                }
            }
        }
    }

    &__report {
        width: 100%;
    }

    &__card {
        min-width: 490px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        border-radius: 0px 40px 0px 20px;
        background: $token-colors-gray-10;
        padding: $token-spacers-m;
        scroll-snap-align: start;

        @include breakpoint(v-tablet) {
            min-width: 360px;
            padding: $token-spacers-s;
        }

        @include breakpoint(mobile) {
            min-width: 288px;
            padding: $token-spacers-xs;
        }
    }

    &__card-title {
        line-height: 140%;
    }
}
</style>
